"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHeaderFixed = void 0;
var react_1 = __importDefault(require("react"));
var useHeaderFixed = function () {
    var _a = react_1.default.useState(0), scrollPosition = _a[0], setScrollPosition = _a[1];
    var scrollHandler = function () {
        setScrollPosition(window.scrollY);
    };
    react_1.default.useEffect(function () {
        window.addEventListener('scroll', scrollHandler);
        return function () { return window.removeEventListener('scroll', scrollHandler); };
    }, []);
    return scrollPosition;
};
exports.useHeaderFixed = useHeaderFixed;
